import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Navigate } from '@ngxs/router-plugin';
import { dispatch, select } from '@ngxs/store';
import { CartAviaItemViewComponent } from '@shared/modules/cart/components/items/cart-avia-item-view/cart-avia-item-view.component';
import { CartExcursionItemViewComponent } from '@shared/modules/cart/components/items/cart-excursion-item-view/cart-excursion-item-view.component';
import { CartHotelItemViewComponent } from '@shared/modules/cart/components/items/cart-hotel-item-view/cart-hotel-item-view.component';
import { CartTourItemViewComponent } from '@shared/modules/cart/components/items/cart-tour-item-view/cart-tour-item-view.component';
import { cartClear, cartRemoveItem } from '@shared/modules/cart/state/cart.actions';
import { CartState } from '@shared/modules/cart/state/cart.state';
import { PriceFormatPipe } from '@shared/pipes/price-format.pipe';

@Component({
  selector: 'app-cart-content-view',
  templateUrl: './cart-content-view.component.html',
  styleUrl: './cart-content-view.component.scss',
  imports: [
    MatIcon,
    CartTourItemViewComponent,
    CartHotelItemViewComponent,
    CartAviaItemViewComponent,
    CartExcursionItemViewComponent,
    MatRipple,
    MatProgressBar,
    MatButton,
    PriceFormatPipe,
    TranslatePipe,
    MatTooltip
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartContentViewComponent {
  readonly closeEvent = output<boolean>();
  readonly items = select(CartState.items);
  readonly totalPrice = select(CartState.totalPrice);

  readonly #navigate = dispatch(Navigate);

  readonly onCartClear = dispatch(cartClear);
  readonly onRemoveItem = dispatch(cartRemoveItem);

  onCheckout() {
    this.closeEvent.emit(true);
    this.#navigate(['/checkout']);
  }
}
